<span class="loading" *ngIf="loading">
  <em class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></em>
</span>
<app-header></app-header>
<app-side-menu-bar></app-side-menu-bar>

<div class="main-content">
  <div class="heading">
    <label class="heading-text">{{LossTreeHeader}}</label>
    <span class="addBtn" *ngIf="isAuthorized">
      <button class="btn btn-primary  save-btn" [ngClass]="enableSaveBtn ? 'enable': 'disable'"
        (click)="saveLossTree()">Save</button>
      <span title="Level0 should be selected to add a new row">
        <button class="btn btn-primary" [ngClass]="clickedLevel1 ? 'enable': 'disable'" (click)="addChild()">
          Add New
        </button></span>
    </span>
  </div>
  <div class="btn-group">
    <div class="dropdown">
      <button type="button" style="margin-left:0px;"
        [ngClass]="btn0Clicked? 'btn btn-primary clicked' : 'btn btn-primary dropdown-toggle notClicked'"
        data-toggle="dropdown">
        Level 0 <em class="fa fa-filter"></em>
      </button>
      <ul class="dropdown-menu">
        <li class="listClass">
          <p class="dropdown-item" title="{{item}}" href="#" *ngFor="let item of levelData"
            (click)="selectedLevelDropDown(item)">
            {{item}}</p>
        </li>
      </ul>
    </div>
    <div class="dropdown">
      <button type="button"
        [ngClass]="btn1Clicked? 'btn btn-primary clicked' : 'btn btn-primary dropdown-toggle notClicked'"
        data-toggle="dropdown">
        Level 1 <em class="fa fa-filter"></em>

      </button>
      <ul class="dropdown-menu">
        <li class="listClass">
          <p class="dropdown-item" title="{{item}}" href="#" *ngFor="let item of levelOneData"
            (click)="selectedLevelOne(item)">
            {{item}}</p>
        </li>
      </ul>
    </div>
    <div class="dropdown">
      <button type="button"
        [ngClass]="btn2Clicked? 'btn btn-primary clicked' : 'btn btn-primary dropdown-toggle notClicked'"
        data-toggle="dropdown">
        Level 2 <em class="fa fa-filter"></em>

      </button>
      <ul class="dropdown-menu">
        <li class="listClass">
          <p class="dropdown-item" title="{{item}}" href="#" *ngFor="let item of levelTwoData"
            (click)="selectedLevelTwo(item)">
            {{item}}</p>
        </li>
      </ul>
    </div>
    <div class="dropdown">
      <button type="button"
        [ngClass]="btn3Clicked? 'btn btn-primary clicked' : 'btn btn-primary dropdown-toggle notClicked'"
        data-toggle="dropdown">
        Level 3 <em class="fa fa-filter"></em>

      </button>
      <ul class="dropdown-menu">
        <li class="listClass">
          <p class="dropdown-item" title="{{item}}" href="#" *ngFor="let item of levelThreeData"
            (click)="selectedLevelThree(item)">
            {{item}}</p>
        </li>
      </ul>
    </div>
    <div class="dropdown">
      <button type="button"
        [ngClass]="btn4Clicked? 'btn btn-primary clicked' : 'btn btn-primary dropdown-toggle notClicked'"
        data-toggle="dropdown">
        Level 4 <em class="fa fa-filter"></em>

      </button>
      <ul class="dropdown-menu">
        <li class="listClass">
          <p class="dropdown-item" title="{{item}}" href="#" *ngFor="let item of levelFourData"
            (click)="selectedLevelFour(item)">
            {{item}}</p>
        </li>
      </ul>
    </div>
    <div class="dropdown">
      <button type="button" class="btn btn-primary dropdown-toggle notClicked" data-toggle="dropdown"
        (click)="resetFilterFunction()">
        Reset Filter <em class="fa fa-undo"></em>
      </button>
    </div>
  </div>
  <div class="example-container mat-elevation-z8">
    <app-table-row [dataSource]="users" [displayedColumns]="displayedColumns" [referenceId]="'level0'"
      [iconKeyReference]="'lossTreeParent'" [renderTemplate]="'relative'" (addBtnEnabled)="addRow($event)"
      (emitBtnEnable)="enableSaveBtnFn($event)" (emitLossTreeData)="getSaveData($event)">
    </app-table-row>

  </div>
</div>